<pf-section name="datenschutz" [title]="'sendmail.form.step.privacy-consent-title' | i18next">
    {{'sendmail.form.step.privacy-consent-text' | i18next}}
</pf-section>
